import { render, staticRenderFns } from "./MXHeader.vue?vue&type=template&id=bcaa22d8&scoped=true"
import script from "./MXHeader.vue?vue&type=script&lang=js"
export * from "./MXHeader.vue?vue&type=script&lang=js"
import "./MXHeader.vue?vue&type=style&index=0&id=bcaa22d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaa22d8",
  null
  
)

export default component.exports